import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker'
import fi from 'date-fns/locale/fi'

// Make datepickers finnish.
registerLocale('fi', fi)
setDefaultLocale('fi')

export default function DateSelect({ date, callback, extraClasses = '' }) {
  return (
    <div
      className={`select-wrap select-wrap--pink pink-datepicker ${extraClasses}`}
    >
      <DatePicker
        selected={date}
        onChange={(selectedDate) => callback(selectedDate)}
        dateFormat="dd. MMM"
      />
    </div>
  )
}
